import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import CustomDialogWrapper from './CustomDialogWrapper/CustomDialogWrapper';

interface SharePointDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SharePointDialog: React.FC<SharePointDialogProps> = ({ open, onClose, onConfirm }) => {
  return (
    <CustomDialogWrapper open={open} onClose={onClose} width="552px" height="352px">
      <Grid
        style={{
          width: '552px',
          height: '352px',
        }}
      >
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '15%',
          }}
        >
          <Typography
            style={{
              fontSize: 26,
              fontWeight: 700,
              lineHeight: '29.26px',
              textAlign: 'center',
              marginTop: '15px',
            }}
          >
            Redirecting...
          </Typography>
        </Grid>
        <Typography
          style={{
            fontSize: 16,
            fontWeight: 400,
            lineHeight: '19.5px',
            textAlign: 'center',
            marginTop: '15px',
          }}
        >
          Will re-direct to SharePoint Folder. Proceed?
        </Typography>

        <Grid
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            marginTop: '20px',
          }}
        >
          <Button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            style={{
              color: 'white',
              background: '#E81C0E',
              width: '362px',
              height: '44px',
              marginBottom: '10px',
              fontSize: 14,
            }}
          >
            Yes
          </Button>
          <Button
            style={{
              border: '0.88px solid #E6E6E6',
              color: 'black',
              background: 'white',
              width: '362px',
              height: '44px',
            }}
            onClick={onClose}
            color="primary"
          >
            No
          </Button>
        </Grid>
      </Grid>
    </CustomDialogWrapper>
  );
};

export default SharePointDialog;
